import { useSelector } from 'react-redux';
import { RootState } from '../app/store';
import { Purpose } from '../pages/MasterData/Purpose/purposeSlice';

export default function useMasterDateForDocumentRevision(): [Purpose[]] {
  const { data: purposes } = useSelector((state: RootState) => state.purposes);
  return [purposes];
}
